module.exports = __webpack_public_path__ + "static/media/awardsbackgroundpage.c9176628.jpg";